const attachEvents = (clickEvent, clickHandlers) => ([context, menuItems]) =>
    menuItems.map((m) => ({
        ...m,
        html: clickEvent(m.html, (el) => clickHandlers[m.name](context, el)),
    }));

export default attachEvents;
